import { Badge, IconButton, Tooltip } from '@mui/material';
import NotificationsIcon from '@mui/icons-material/Notifications';
import { useNotificationPolling } from '../../hooks/useNotificationPolling';
import { useNavigate } from 'react-router-dom';

interface NotificationBadgeProps {
  enabled?: boolean;
}

export default function NotificationBadge({ enabled = true }: NotificationBadgeProps) {
  const navigate = useNavigate();
  const { unreadCount, lastChecked } = useNotificationPolling({ enabled });

  const handleNotificationClick = () => {
    navigate('/dashboard/notifications');
  };

  return (
    <Tooltip 
      title={
        unreadCount > 0 
          ? `${unreadCount} unread notification${unreadCount > 1 ? 's' : ''}` 
          : lastChecked 
            ? `No new notifications (checked ${lastChecked.toLocaleTimeString()})` 
            : 'No notifications'
      }
    >
      <IconButton 
        onClick={handleNotificationClick}
        sx={{ 
          color: 'inherit',
          '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.1)'
          }
        }}
      >
        <Badge 
          badgeContent={unreadCount} 
          color="error"
          max={99}
          sx={{
            '& .MuiBadge-badge': {
              right: -3,
              top: -3,
              fontSize: '0.7rem',
              height: 18,
              minWidth: 18,
              animation: unreadCount > 0 ? 'pulse 2s infinite' : 'none',
              '@keyframes pulse': {
                '0%': {
                  transform: 'scale(1)',
                },
                '50%': {
                  transform: 'scale(1.1)',
                },
                '100%': {
                  transform: 'scale(1)',
                },
              },
            }
          }}
        >
          <NotificationsIcon />
        </Badge>
      </IconButton>
    </Tooltip>
  );
} 